import styles from './ProjectPhotos.module.scss';
import Slider from 'react-slick';

import Arrow from '../../../../../images/arrow-blue.svg';

import FullScreenImage from '../../../Objects/ObjectsContent/FullScreenImage/FullScreenImage';
import { useState } from 'react';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectPhotos = ({ props }) => {
  const [isDragging, setIsDragging] = useState(false); // Флаг для отслеживания свайпа

  const [showFullScreenImage, setShowFullScreenImage] = useState(false);
  const [currentPhoto, setCurrentPhoto] = useState();

  const openFullScreenImg = (clickedPhoto) => {
    setCurrentPhoto(clickedPhoto);
    setShowFullScreenImage(true);
  };

  const next = () => {
    if (!currentPhoto) return;
    const currentIndex = props.findIndex((item) => item.image === currentPhoto);
    if (currentIndex === -1) return;
    const nextIndex = (currentIndex + 1) % props.length;
    setCurrentPhoto(props[nextIndex].image);
  };
  const prev = () => {
    if (!currentPhoto) return;
    const currentIndex = props.findIndex((item) => item.image === currentPhoto);
    if (currentIndex === -1) return;
    const prevIndex = (currentIndex - 1 + props.length) % props.length;
    setCurrentPhoto(props[prevIndex].image);
  };

  const CustomPrevArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
        }}
        onClick={onClick}
        className={classnames(isMobile ? [styles.arrow, styles.mobile] : [styles.arrow])}>
        <img src={Arrow} alt="" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  const CustomNextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <button
        style={{
          ...style,
          display: 'block',
          backgroundColor: 'transparent',
          width: '30px',
          height: '30px',
          rotate: '180deg',
        }}
        onClick={onClick}
        className={classnames(isMobile ? [styles.arrow, styles.mobile] : [styles.arrow])}>
        <img src={Arrow} alt="" width={30} height={30} style={{ display: 'block' }} />
      </button>
    );
  };

  // отмена клика через PreventDefault
  const handleLinkMouseDown = (e) => {
    // Запоминаем начальную позицию и сам элемент
    const startX = e.clientX;
    const linkElement = e.currentTarget; // Сохраняем ссылку на DOM-элемент

    const handleMouseMove = (e) => {
      // Если движение мыши > 5px — это свайп, отменяем клик
      if (Math.abs(e.clientX - startX) > 5) {
        e.preventDefault();
        if (linkElement) {
          // Проверяем, что элемент существует
          linkElement.style.pointerEvents = 'none';
        }
      }
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      // Восстанавливаем события через 100 мс
      setTimeout(() => {
        if (linkElement) {
          linkElement.style.pointerEvents = 'auto';
        }
      }, 100);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp, { once: true });
  };

  const settings = {
    dots: false,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    infinite: props.length > 6 ? true : false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    // autoplaySpeed: 100,
    draggable: true,
    lazyLoad: true,
    swipeToSlide: true,

    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          infinite: props.length > 5 ? true : false,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          infinite: props.length > 4 ? true : false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          infinite: props.length > 3 ? true : false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          infinite: props.length > 1 ? true : false,
        },
      },
    ],
  };

  // if (props.length === 1) return <></>;

  return (
    <section className={classnames(isMobile ? [styles.section, styles.mobile] : [styles.section])} id="projectPhotos">
      <h2 className={classnames(isMobile ? [styles.title, styles.mobile] : [styles.title])}>Галерея изображений</h2>

      {showFullScreenImage && (
        <FullScreenImage
          imageList={props}
          prev={prev}
          next={next}
          current={currentPhoto}
          close={() => setShowFullScreenImage(false)}
        />
      )}

      <Slider {...settings}>
        {props.map((item) => {
          return (
            <button
              key={item.id}
              className={styles.item}
              onClick={(e) => {
                if (isDragging) {
                  e.preventDefault();
                  return;
                }
                openFullScreenImg(item.image);
              }}
              onMouseDown={handleLinkMouseDown}>
              <div className={styles.sliderImage}>
                <img src={item.image} alt={item.title} />
              </div>
            </button>
          );
        })}
      </Slider>
    </section>
  );
};

export default ProjectPhotos;
